import Brand from 'data/Brand';
import { navigate } from 'hooks/useHookRouterCompat';
import { Size } from 'lib/styles';
import React from 'react';
import styled from 'styled-components';
import { Background, Border, Main } from 'styles/themeColors';
import placeholderImage from 'images/placeholder-image.jpg';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import BrandType from './BrandTypeChip';
import FeatureFlag from 'data/FeatureFlag';
import { BRAND_TYPE } from 'constants/brands';
import { ReadOnlyWrapper } from 'components/common/ReadOnlyWrapper';

const BRAND_CARD_LABELS = {
  LOGO_ALT: (name: string) => `${name} logo`,
  PLACEHOLDER_ALT: (name: string) => `${name} placeholder-logo`,
};

const Label = styled.div`
  font-size: 24px;
`;

const BrandImage = styled.img`
  height: 40px;
  margin-right: ${Size.medium};
  object-fit: contain;
  object-position: 50%;
  width: 40px;
`;

const Card = styled.div`
  border: 1px solid ${Border.main};
  padding: 10px;
  background: ${Background.light};
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 6px;
  min-height: 64px;
  justify-content: space-between;
  cursor: pointer;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  width: 100%;

  &:hover {
    border-color: ${Main.brandDark};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

const Tag = styled.div`
  align-self: flex-start;
`;

interface Props {
  brand: Brand;
  featureFlags?: FeatureFlag;
  readOnly: boolean;
}

const BrandCard: React.FC<Props> = ({ brand, readOnly }: Props) => {
  return (
    <ReadOnlyWrapper readOnly={readOnly}>
      <Card
        key={brand.id}
        onClick={readOnly ? undefined : () => navigate(`/brands/brand-details/${brand.id}`)}
      >
        <FlexboxContainerComponent>
          {brand.media && brand.media.length > 0 ? (
            <BrandImage
              alt={BRAND_CARD_LABELS.LOGO_ALT(brand.name)}
              src={process.env.REACT_APP_MEDIA_URL + brand.media[0].path}
            />
          ) : (
            <BrandImage
              alt={BRAND_CARD_LABELS.PLACEHOLDER_ALT(brand.name)}
              src={placeholderImage}
            />
          )}
          <Label>{brand.name}</Label>
        </FlexboxContainerComponent>

        <Tag>
          <BrandType type={BRAND_TYPE.BRAND} />
        </Tag>
      </Card>
    </ReadOnlyWrapper>
  );
};

export default React.memo(BrandCard);